import { decodeJwtBody } from "@maersk-global/shared-js";
import { GRAFANA_CONFIG } from "../utils/application";
import { AppPathConfig } from "@/helper/app_path_config";

export const storeDataInLS = (key, data, ttlMinutes) => {
  const now = new Date().getTime();
  const item = {
    data,
    expiry: now + ttlMinutes * 60 * 1000 // Convert minutes to milliseconds
  };
  localStorage.setItem(key, JSON.stringify(item));
};

// Function to retrieve data and check expiration
export const getDataFromLS = (key) => {
  if (key === "savedLocation") {
    return localStorage.getItem(key) || null;
  }
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = new Date().getTime();

  if (now > item.expiry) {
    localStorage.removeItem(key);
    return null; // Data has expired
  }
  return item.data;
};

export const getJwtToken = (tokenType = "id_token") => {
  let token: any;

  for (const [key, value] of Object.entries(localStorage)) {
    if (key.includes(`.${tokenType}`)) {
      token = value;
    }
  }
  // tokenType = id_token -> localStorage.getItem("al.https://accounts-cdt.apmterminals.com/root-cdt.apmt001.id_token");
  // tokenType = access_token -> localStorage.getItem("al.https://accounts-cdt.apmterminals.com/root-cdt.apmt001.access_token");
  return token;
};

export const isAuthenticatedUser = (): boolean => {
  const jwt = getJwtToken("access_token");
  const decodedJwt: any = decodeJwtBody(jwt);
  return !decodedJwt?.error && decodedJwt?.exp >= Date.now() / 1000;
};

export const clearLocalStorageData = (): void => {
  localStorage.removeItem("saveContainerTerminal");
  localStorage.removeItem("selectedContainers");
  localStorage.removeItem("terminalNav");
  localStorage.removeItem("containerNumbers");
};

export const checkDeviceType = () => {
  // Check if the device is a desktop/laptop
  if (/desktop|pc/i.test(navigator.userAgent)) {
    return "You are using a desktop or laptop.";
  }

  // Check if the device is a tablet
  if (/tablet/i.test(navigator.userAgent)) {
    return "You are using a tablet.";
  }

  // Check if the device is a mobile phone
  if (/mobile/i.test(navigator.userAgent)) {
    return "You are using a mobile phone.";
  }

  // Check if the device is running iOS
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    return "You are using an iOS device.";
  }

  // Check if the device is running Android
  if (/Android/.test(navigator.userAgent)) {
    return "You are using an Android device.";
  }

  // Check if the device is a Mac
  if (navigator.platform.toUpperCase().indexOf("MAC") >= 0) {
    return "You are using a Mac.";
  }

  // Check if the device is a Windows PC
  if (navigator.platform.toUpperCase().indexOf("WIN") >= 0) {
    return "You are using a Windows PC.";
  }
};

export const getEnvironmentLabel = (): string => {
  let environmentCode: string;
  const env = window.location.host?.split(".")[0];

  switch (env) {
    case "www":
      environmentCode = "prod";
      break;
    case "stage":
    case "uat":
      environmentCode = "preprod";
      break;
    case "cdt":
    case "dev":
      environmentCode = "test";
      break;
    default:
      environmentCode = "localhost";
      break;
  }

  return environmentCode;
};

export const grafanaConfig = () => {
  const environmentLabel: string = getEnvironmentLabel();
  return GRAFANA_CONFIG[environmentLabel] || GRAFANA_CONFIG["localhost"];
};

export const setInternalRedirectForTerminal = (journeyPath: string, terminalId: string): void => {
  const normalizedJourneyPath = journeyPath.startsWith("/") ? journeyPath.slice(1) : journeyPath;
  const appBasePath = window.location.pathname.split(AppPathConfig.appRouteBaseURL)[0] + AppPathConfig.appRouteBaseURL;
  const redirectUri = `${appBasePath}${normalizedJourneyPath}?terminal=${terminalId}`;
  localStorage.setItem("internal-redirect", JSON.stringify({ redirectUri }));
};
